import {
    useGetAziendeCdiCQuery,
    useGetAziendeGruppiQuery,
    useGetAziendeMansioneQuery,
    useGetAziendeQualificaQuery,
    useGetAziendeRuoloQuery,
    useGetAziendeTipoContrattoQuery,
    useGetDefinizioniGruppiQuery
} from "@commons/features/azienda/tabelle/aziendaMapping.api";
import {CentroDiCostoRecord} from "@commons/mapping/CentroDiCostoRecord";

export interface Tabella {
    descrizione?: string,
    data: CentroDiCostoRecord[] | undefined,
    isLoading: boolean,
}

const useTabellaQuery = (idAzienda: number, idTipo: number) => {
    const {data, isLoading} = useGetAziendeGruppiQuery({idAziendaMaster: idAzienda, idGruppo: idTipo});
    return {data, isLoading};
}
export const useAziendaTabelle = (idAzienda: number) => {

    const {data: dataDefGruppi, isLoading: isLoadingDefGruppi} = useGetDefinizioniGruppiQuery({
        idAziendaMaster: idAzienda
    });

    const {data: dataCdiC, isLoading: isLoadingCdiC} = useGetAziendeCdiCQuery({idAziendaMaster: idAzienda});
    const {data: dataMansione, isLoading: isLoadingMansione} = useGetAziendeMansioneQuery({idAzienda: idAzienda});
    const {data: dataRuolo, isLoading: isLoadingRuolo} = useGetAziendeRuoloQuery({idAzienda: idAzienda});
    const {data: dataQualifica, isLoading: isLoadingQualifica} = useGetAziendeQualificaQuery({idAzienda: idAzienda});
    const {data: dataTipoContratto, isLoading: isLoadingTipoContratto} = useGetAziendeTipoContrattoQuery({idAzienda: idAzienda});

    const gruppi = [
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_01'))!.descrizione : 'GruppoBase 1', ...useTabellaQuery(idAzienda, 1)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_02'))!.descrizione : 'GruppoBase 2', ...useTabellaQuery(idAzienda, 2)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_03'))!.descrizione : 'GruppoBase 3', ...useTabellaQuery(idAzienda, 3)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_04'))!.descrizione : 'GruppoBase 4', ...useTabellaQuery(idAzienda, 4)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_05'))!.descrizione : 'GruppoBase 5', ...useTabellaQuery(idAzienda, 5)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_06'))!.descrizione : 'GruppoBase 6', ...useTabellaQuery(idAzienda, 6)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_07'))!.descrizione : 'GruppoBase 7', ...useTabellaQuery(idAzienda, 7)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_08'))!.descrizione : 'GruppoBase 8', ...useTabellaQuery(idAzienda, 8)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_09'))!.descrizione : 'GruppoBase 9', ...useTabellaQuery(idAzienda, 9)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_10'))!.descrizione : 'GruppoBase 10', ...useTabellaQuery(idAzienda, 10)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_11'))!.descrizione : 'GruppoBase 11', ...useTabellaQuery(idAzienda, 11)},
        {descrizione: dataDefGruppi ? dataDefGruppi.find((def) => (def.idTipo === 'GRUPPO_12'))!.descrizione : 'GruppoBase 12', ...useTabellaQuery(idAzienda, 12)},
    ];

    return {
        dataCdiC, isLoadingCdiC,
        gruppi,
        dataMansione, isLoadingMansione,
        dataRuolo, isLoadingRuolo,
        dataQualifica, isLoadingQualifica,
        dataTipoContratto, isLoadingTipoContratto,
    };
}